/*!
 * 方案 动画操作 v 1.0
 * 2022.12
 *
 */
import screenplayFn from "@/components/tables/program/screenplayFn.js";

/**
 * 处理 动画数据
 * @returns { any }
 */
export function processingData(data, animationData) {
  // console.log(data, animationData);
  let { add, item, remove } = data;
  add.forEach((element) => {
    console.log(element);
    animationData.find((e) => {
      if (e.id == element) {
        let { operation, operationObject, operationType } = e;
        console.log(operationType);
        switch (operationType) {
          case "model":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("add", operationObject);
            }
            break;
          case "kml":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("true", operationObject);
            }
            break;
          case "shp":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("true", operationObject);
            }
            break;
          case "plot":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("true", operationObject);
            }
            break;
          default:
            break;
        }
      }
    });
  });
  remove.forEach((element) => {
    animationData.find((e) => {
      if (e.id == element) {
        console.log(e);
        let { operation, operationObject, operationType } = e;
        switch (operationType) {
          case "model":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("remove", operationObject);
            }
            break;
          case "kml":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("false", operationObject);
            }
            break;
          case "shp":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("false", operationObject);
            }
            break;
          case "plot":
            if (operation == "show") {
              console.log(screenplayFn[operationType][operation]);
              screenplayFn[operationType][operation]("false", operationObject);
            }
            break;
          default:
            break;
        }
      }
    });
  });
}
